/**
 * Sanitizes a given string to CSS <custom-ident> type
 * https://www.w3.org/TR/css-values-3/#custom-idents
 *
 * @param {string} ident
 * @returns {string}
 */
export function toCSSCustomIdent(ident) {
    return ident.replace(/ /g, '').replace(/[^\w]/g, '\\$&');
}
//# sourceMappingURL=cssUtils.mjs.mjs.map